export default __webpack_public_path__ + "media/images/ui-icons_3d80b3_256x240-205a7ce2e39007d40bdbf94825c724b0.png";